import type { Content } from '@tiptap/core';

export const shouldShowEmptyState = (content?: Content): boolean => {
  if (!content) return true;
  if (typeof content === 'string') return content.trim().length === 0;
  if (Array.isArray(content)) return content.length === 0;
  if (content.type !== 'doc') return false;

  if (!content.content || content.content.length === 0) return true;

  return content.content.every(item => {
    if (item.type !== 'paragraph' && item.type !== 'heading') return false;
    return !item.content || item.content.length === 0;
  });
};
